export default __webpack_public_path__ + "static/houses_2-826c229a970c1946bd00f69d75aa9dd3.png";